import isString from 'lodash/isString'
import { OdometerType } from '@carsys/enums/odometer-type'

export const getDefaultOdometerType = (countryCode: string | null | undefined): OdometerType => {
  if (!isString(countryCode)) {
    return OdometerType.Kilometers
  }
  if (countryCode === 'UK') {
    return OdometerType.Miles
  }
  // in all other countries; assume we want to use Kilometers
  return OdometerType.Kilometers
}
